export function convertKeyToValue(baseObject:any, fieldParam:string):any {
	let properties:Array<string> = fieldParam.split(".");
	return properties.reduce((accumulator, currentVal:string) => {
		if (!!accumulator) {
			return (!!accumulator[currentVal] ? accumulator[currentVal] : null)
		}
	}, baseObject);
}
